module.exports = __webpack_public_path__ + "img/yukiri.e94c4a6a.jpg";